<template>
  <v-dialog v-model="dialog" persistent max-width="1000px">
    <v-container>
      <v-card>
        <v-toolbar class="headline" color="primary" dark>食事設定（日毎）</v-toolbar>
        <v-card-title class="noPaddingBtm">
          {{this.viewTime}}
        </v-card-title>
        <v-card-title class="noPaddingTopBtm">
            <v-switch v-model="teikyouSwitch" color="success" :label="`提供あり`" :disabled="switchCtrl" dense>
            </v-switch>
            <v-switch v-model="holidaySwitch" color="success" :label="`休日`" :disabled="switchCtrl" @change="holidayChange" dense>
            </v-switch>
        </v-card-title>
        <v-card-text>
          <v-card class="HigotoTextBox">
            <v-card-text>
              <v-container style="height: 260px;overflow-y: auto;">
                <v-row v-for="(item, index) in contentValue" :key="index">
                  <v-col cols="1">
                    <v-subheader>{{item.meal_class}}</v-subheader>
                  </v-col>
                  <v-col cols="2">
                    <v-subheader :style="GetBgRGB(index)">
                      <div class="MenuStyle">
                        {{item.meal_name}}
                      </div>
                    </v-subheader>
                  </v-col>
                  <v-col cols="6">
                    <ryou-input label="食事メニュー" v-model="item.menu" :value="item.menu" :maxlength="15"
                      :disabled="inpBtnCtrl">
                    </ryou-input>
                  </v-col>
                  <v-col cols="3">
                    <v-card-title class="noPaddingTopBtm">
                      <v-switch v-model="item.offer_flg_mc" color="success" :label="`提供あり`"  :disabled="inpBtnCtrl" dense>
                      </v-switch>
                    </v-card-title>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :disabled="ryouBtnCtrl"
                :iconCls="'mdi-close'"></ryou-black-btn>
              <v-spacer></v-spacer>
              <ryou-black-btn :label="'登録'" :handlerClick="changeOfferConfirm" :disabled="inpBtnCtrl || ryouBtnCtrl">
              </ryou-black-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </v-container>
    <ryou-confirm ref="confirm"></ryou-confirm>
  </v-dialog>
</template>

<script>
  import RyouInput from "@/components/formInput/RyouInput.vue";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import RyouConfirm from "@/components/dialog/RyouConfirm.vue";

  export default {
    name: "MealLunchDialog",
    components: {
      RyouInput,
      RyouBlackBtn,
      RyouConfirm,
    },
    data() {
      return {
        dialog: false,
        time: "",
        viewTime: "",
        watchTeikyouSwitch: null,
        teikyouSwitch: null,
        teikyouSwitchOfClass: null,
        holidaySwitch: true,
        dialogMealNames: [],
        contentValue: [],
        ryouBtnCtrl: false,
        switchCtrl: null,     //締め切り選択ボタンのコントロールフラグ
        inpBtnCtrl: null,     //メニュー、設定ボタンのコントロールフラグ
        dialogReservFlg: null,//true:締め切り以下、false:締切日より小さくない 
        groupOptionValue: "",
        updateResult: {},
        message: "提供なしに設定した場合、その食事予約がキャンセルされ、メニューが削除されます。宜しいですか？",
        offerFlgs:[]
      };
    },
    watch: {
      teikyouSwitch(value) {
        
        //締切日を過ぎている場合
        if (this.dialogReservFlg) {
          this.inpBtnCtrl = true;
          this.switchCtrl = true;
        }
        else {
          if (value) {
            this.inpBtnCtrl = false;
          }
          else {
            this.inpBtnCtrl = true;
            this.holidaySwitch = false;
          }
        }
    },
  },
    methods: {
      sortbyKey(arr, key) {
        if (arr.length > 0) {
          return arr.sort((a, b) => {
            let x = a[key];
            let y = b[key];

            return x - y;
          })
        }
      },
      //クリックを閉じる
      handleCancel() {
        this.close();
      },
      watchingTeikyouSwitch(value) {
        this.watchTeikyouSwitch = value;

        let updateResultBean = {
          build_group_id: this.groupOptionValue,
          input_date: this.time,
          offer_flg: Number(this.teikyouSwitch).toString(),
          user_id: this.$store.getters.getUserId,
        };
       
        if (this.watchTeikyouSwitch) {
          this.putRequest("/mealLunchSetting/mealOfferTUpdate", updateResultBean, this.$store.getters.getUserToken).then((resp) => {
            if (!resp.success) {
              this.close()
            }
          });
           //提供無しへ変更する場合は確認メッセージを表示する。
        } else {
          this.$refs.confirm.open("更新", this.message, { color: "warning" })
            .then((confirm) => {
              if (confirm) {
                //OK押下時、レコード更新
                this.putRequest("/mealLunchSetting/mealOfferTUpdate", updateResultBean, this.$store.getters.getUserToken).then((resp) => {
                  if (resp.success) {

                    //提供なしにした際、メニュー文字列クリア
                    this.contentValue.forEach((item) => {item.menu = "";});
                    this.inpBtnCtrl = true;

                  } else {

                    //更新不可であればダイアログを閉じる
                    this.close()

                  }
                });
              } else {
                //キャンセル押下時、フラグをもとに戻す
                this.teikyouSwitch = true;
              }
            });
        } 
       
      },
      removeWatchingTeikyouSwitch() {

        if (this.unwatch) {
          this.unwatch();
        }
      },
        holidayChange() {
            let updateResultBean = {
                build_group_id: this.groupOptionValue,
                input_date: this.time,
                holiday_flg: Number(this.holidaySwitch).toString(),
                user_id: this.$store.getters.getUserId,
            };
            this.putRequest("/mealLunchSetting/mealHolidayUpdate", updateResultBean, this.$store.getters.getUserToken).then((resp) => {
                if (!resp.success) {
                    this.close()
                }
            });
      },
      //クリックを確定
      confirm() {
        this.$refs.confirm.open("更新", "更新します。宜しいですか？", { color: "info" })
          .then((confirm) => {
            if (confirm) {
              this.submit();
            }
          });
      },
      //オファーフラグ更新の確認ダイアログ
      changeOfferConfirm(){
        //提供有無なしに変更されていないか判定
        var flg = false
        for (var key in this.contentValue) {
          if (this.contentValue[key].offer_flg_mc != this.offerFlgs[key] && this.offerFlgs[key] == 1) {
            flg = true;
          }
        }

        //確認メッセージを表示
        if (flg) {
          this.$refs.confirm.open("更新", this.message, { color: "warning" })
            .then((confirm) => {
              if (confirm) {
                this.submit()
              }
            });
        } else {
          this.confirm()
        }
        
      },
      submit() {

        let updateResultBean = {
          build_group_id: this.groupOptionValue,
          input_date: this.time,
          user_id: this.$store.getters.getUserId,
          menu_entity: []
        };
        this.updateResult = updateResultBean;

        this.contentValue.forEach((item) => {
          let updateItem = {
            meal_class: item.meal_class,
            menu: item.menu,
            offer_flg_mc: Number(item.offer_flg_mc).toString()
          };
          this.updateResult.menu_entity.push(updateItem);
        });
        this.ryouBtnCtrl = true;
        this.putRequest("/mealLunchSetting/mealMenuUpdate", this.updateResult, this.$store.getters.getUserToken).then(() => {
          this.ryouBtnCtrl = false;
            this.close();
        });
      },
      //ページローディング要求インターフェース、取得値
      // パラメータ1:ダイアログデータ、パラメータ2:物件グループID
      // パラメータ3:食事提供有無フラグ、パラメータ4:締め切りフラグ
      //パラメータ5:[食事区分&食事名]
      getInputValue(value, selectOptionValue, offerCheckFlg, reservCheckFlg, mealNames) {
        if (selectOptionValue) {
          this.groupOptionValue = selectOptionValue;
        }
        //タイプ判定
        if (value instanceof Object) {

          //提供あり＝＞インプット有効, 提供なし＝＞インプット無効
          if (offerCheckFlg) {
            this.inpBtnCtrl = false;
          } else {
            this.inpBtnCtrl = true;
          }
          if (reservCheckFlg) {
            this.dialogReservFlg = true;
          } else {
            this.dialogReservFlg = false;
          }
          for (let dialogDataIndex in value) {//多分不要なfor文
            //日付をフォーマット
            this.time = dialogDataIndex;  // yyyy-MM-dd
            let timelist = dialogDataIndex.split("-");  //  [yyyy,MM,dd]
            this.viewTime =      //  yyyy年M月d日
              timelist[0] + "年"
              + (timelist[1][0] == "0" ? timelist[1][1] : timelist[1]) + "月"
              + (timelist[2][0] == "0" ? timelist[2][1] : timelist[2]) + "日";

            var mapDatas = value[dialogDataIndex].map(item => {
              item.offer_flg_mc = Number(item.offer_flg_mc)
              return item
            });

            //１つめの食事区分で判定し、値をセット
            this.contentValue = mapDatas;

            //ダイアログを開いた時点の区分毎の提供有無を保持
            for (var key in this.contentValue) {
              this.offerFlgs.push(this.contentValue[key].offer_flg_mc)
            }

            if (this.contentValue[0].offer_flg != "") {
              this.teikyouSwitch = Number(this.contentValue[0].offer_flg);
              this.unwatch = this.$watch('teikyouSwitch', this.watchingTeikyouSwitch)//ウォッチの別の書き方らしい watch( 監視対象 , 実行関数 ）
              }

            // 休日フラグ
              if (this.contentValue[0].holiday_flg != "") {
                  this.holidaySwitch = Number(this.contentValue[0].holiday_flg); // 
            }
          }
          if (mealNames) {
            this.dialogMealNames = mealNames;

            for (let dmnIndex = 0; dmnIndex < this.dialogMealNames.length; dmnIndex++) {

              let notExistFlg = 0;
              for (let cvIndex = 0; cvIndex < this.contentValue.length; cvIndex++) {

                if (this.dialogMealNames[dmnIndex].meal_class == this.contentValue[cvIndex].meal_class) {
                  notExistFlg += 0;
                } else {
                  notExistFlg += 1;
                }

              }
              //食事区分に含まれないデータがある場合
              if (notExistFlg == this.contentValue.length) {
                let emptyMenu = { "menu": "" };
                let contentItem = {
                  ...this.dialogMealNames[dmnIndex],
                  ...emptyMenu
                }
                this.contentValue.push(contentItem);
                this.sortbyKey(this.contentValue, 'meal_class');
              }
            }
          }
        }
        //提供・メニューデータがない日付をクリックした場合
        else {
          this.time = value;
          let timelist = value.split("-");
          this.viewTime =
            timelist[0] + "年"
            + (timelist[1][0] == "0" ? timelist[1][1] : timelist[1]) + "月"
            + (timelist[2][0] == "0" ? timelist[2][1] : timelist[2]) + "日";

          this.inpBtnCtrl = true;
          this.switchCtrl = true;
          this.teikyouSwitch = false;
          this.holidaySwitch = false;
          this.contentValue = [];
          this.dialogMealNames = [];
        }

        this.open();
      },
      close() {
        this.dialog = false;
        this.removeWatchingTeikyouSwitch();
        this.clearParameters();
        this.$emit("reCalendar");
      },
      open() {
        this.dialog = true;
      },
      GetBgRGB(value) {
        let BgRGB = [
          "#FF9800",//オレンジ
          "#673AB7",//深紫
          "#4CAF50",//緑
          "#E91E63",//ピンク
          "#3F51B5",//インディゴ
          "#009688",//teal
          "#FF5722",//深オレンジ
          "#8BC34A",//light-green
          "#D32F2F",//red darken-2
          "#1565C0"//blue darken-3
        ]
        if (this.contentValue[value].offer_flg_mc == "0") {
          return {
            background: "#bebebe"
          }
        }
        else if (this.dialogReservFlg) {
          return {
            background: "#795548"
          };
        }
        else {
          return {
            background: BgRGB[value]
          };
        }
      },
      // パラメータをクリア
      clearParameters() {
        this.teikyouSwitch = null;
        this.watchTeikyouSwitch = null;
        this.contentValue = [];
        this.dialogMealNames = [];
        this.dialogReservFlg = null;
        this.groupOptionValue = "";
        this.inpBtnCtrl = null;
        this.switchCtrl = null;
      }
    },
  };
</script>

<style scoped>
  .noPaddingBtm {
    padding-bottom: 0px;
  }

  .noPaddingTopBtm {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .HigotoTextBox {
    outline: 1px solid rgb(0, 225, 255);
  }

  .MenuStyle {
    width: 100%;
    height: 100%;
    color: white;
    font-weight: bold;
    text-align: center;
    line-height: 48px;
  }
</style>